import script from "./TemplateVariableShortcuts.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateVariableShortcuts.vue?vue&type=script&setup=true&lang=js"

import "./TemplateVariableShortcuts.vue?vue&type=style&index=0&id=1d3b58f9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d3b58f9"]])

export default __exports__